import CityPageTemplate from "../city-template/CityPageTemplate";
import { clarksburgConfig } from "./data";

export default function ClarksburgPage() {
  return <CityPageTemplate config={clarksburgConfig} />;
}